import type { Action } from 'state/actions';
import { addOrReplaceKey, patchKey, removeKey, removeKeys } from 'state/utils/collection';

import type { FormDataStateMap } from '../formData.model';

export function enrichedReducer(state: FormDataStateMap = {}, action: Action): FormDataStateMap {
  switch (action.type) {
    case 'FORM_ENRICHED_DATA_RECEIVED':
      return addOrReplaceKey(state, action.formId, action.data);
    case 'WORKSPACE_TAB_REMOVED':
      return removeKey(state, action.id);
    case 'BATCH_FORMS_DELETED':
      return removeKeys(state, action.formIds);
    case 'WORKSPACE_RESET_TAB_REQUESTED':
      return removeKey(state, action.tabId);
    case 'ADDON_MANAGEMENT_FORMS_RECEIVED':
      return { ...state, ...Object.fromEntries(action.forms.map(form => [form.negotiationId, form.values])) };
    case 'ADDON_MANAGEMENT_QUOTE_RECEIVED': {
      const { formId, quote } = action;
      const solvingMode = state[formId]?.SolvingMode as string;
      const tradingPrice = quote.quoteDetails?.TradingPrice ?? 0;

      const solveResult = quote.solveResult
        ? Number(new Intl.NumberFormat('en-US', { maximumFractionDigits: 4 }).format(quote.solveResult * 100))
        : undefined;

      if (quote.status !== 'Quoted') {
        return state;
      }

      return patchKey(
        state,
        formId,
        data => ({
          ...data,
          ...{ [solvingMode]: solveResult, TradingPrice: tradingPrice },
        }),
        {
          action,
          reducer: 'formData/enriched',
        },
      );
    }
    case 'ADDON_MANAGEMENT_FORM_DATA_CHANGED_WITHOUT_PATCH': {
      return patchKey(state, action.formId, data => ({ ...data, ...{ [action.key]: action.value } }), {
        action,
        reducer: 'formData/enriched',
      });
    }
    default:
      return state;
  }
}
